// FILE: src/components/SubscriptionUpgradeModal.tsx

import * as React from "react";
import Component from "src/components/Component";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  CircularProgress,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItemText,
  Grid,
} from "@material-ui/core";
import { withStyles, WithStyles } from "@material-ui/core/styles";
import withAxios, { IAxiosProps } from "src/components/withAxios";
import CloseIcon from "@material-ui/icons/Close";
import { IUser } from "src/services";

const styles = () => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

interface IProps extends IAxiosProps, WithStyles<keyof ReturnType<typeof styles>> {
  open: boolean;
  onClose: () => void;
  selectedRow?: any;
  onUpgradeSubmit?: () => void;
}

interface IState {
  loading: boolean;
  planOptions: any[];
  addonOptions: any[];
  selectedPlan: number | null;
  addonSelect: any[];
  membershipIds: any[];
  editPaymentOptions: string;
  isCustomPriceEnabled: boolean;
  customPlanPrice: number;
  customAddonPrices: Record<string | number, number>;
  customPlanPriceInput: string;
  customAddonInputs: Record<string | number, string>;
  planStandardPrice: number;
}

class SubscriptionUpgradeModal extends Component<IProps, IState> {
  public readonly state: IState = {
    loading: false,
    planOptions: [],
    addonOptions: [],
    selectedPlan: 1,
    addonSelect: [],
    membershipIds: [],
    editPaymentOptions: 'cheque',
    isCustomPriceEnabled: false,
    customPlanPrice: 0,
    customAddonPrices: {},
    customPlanPriceInput: "",
    customAddonInputs: {},
    planStandardPrice: 0,
  };

  
  public componentDidMount() {
    this.initializeModalData();
  }





// public async initializeModalData() {
//     this.setState({ loading: true });

//     try {
//       const planRes: any = await this.buildGet(this, "payment/getPlan")();
//       const addonRes: any = await this.buildGet(this, "payment/getAddonPlan")();

//       console.log("Plan Response11:", planRes);
//       console.log("Addon Response22:", addonRes);

//       const planOptions = planRes?.data?.map((item: any) => ({
//         label: item?.title,
//         value: item?.id,
//         price: item?.price,
//       })) || [];

//       const addonOptions = addonRes?.data?.map((item: any) => ({
//         label: item?.title,
//         value: item?.id,
//         price: item?.price,
//       })) || [];

//       console.log("Plan Options:", planOptions);
//       console.log("Addon Options:", addonOptions);

//       const { selectedRow } = this.props;
//       console.log("Selected Row:", selectedRow);

//       const planId = selectedRow?.memberPayHistory?.plan?.id > 1
//         ? selectedRow?.memberPayHistory?.plan?.id
//         : 1;

//       const initialPlanMatch: any = planOptions?.find((p: any) =>
//         Number(p.value) === Number(planId)
//       );
//       const initialPlanPrice: number = initialPlanMatch
//         ? Number(initialPlanMatch.price)
//         : 0;

//       console.log("Setting state with planOptions:", planOptions);

//       this.setState({
//         planOptions,
//         addonOptions,
//         selectedPlan: planId,
//         planStandardPrice: initialPlanPrice,
//         customPlanPrice: selectedRow?.memberPayHistory?.price || 0,
//         isCustomPriceEnabled: selectedRow?.is_custom_price || false,
//         customPlanPriceInput: (selectedRow?.memberPayHistory?.price !== undefined &&
//           selectedRow?.memberPayHistory?.price !== null &&
//           selectedRow?.is_custom_price)
//           ? `${Number(selectedRow?.memberPayHistory?.price).toFixed(2)}`
//           : "",
//         editPaymentOptions: selectedRow?.subscription_type || 'cheque',
//         loading: false
//       }, () => {
//         console.log("State after update:", this.state);
//         if (selectedRow?.memberPayHistory?.subscription_id) {
//           this.loadAddonsForSelectedPlan();
//         }
//       });
//     } catch (error) {
//       console.error("Error initializing modal:", error);
//       alert("Error loading plans: " + error);
//       this.setState({ loading: false });
//     }
//   }

  

  // public async loadAddonsForSelectedPlan() {
  //   const { selectedRow } = this.props;
  //   if (!selectedRow?.memberPayHistory?.subscription_id) {
  //     return;
  //   }

  //   this.setState({ loading: true });
  //   try {
  //     const res: any = await this.buildGet(
  //       this,
  //       `payment/getOneAddonHistory/${selectedRow.memberPayHistory.subscription_id}`
  //     )();

  //     if (res?.status && Array.isArray(res.data)) {
  //       const customAddonPrices: Record<number, number> = {};
  //       const customAddonInputs: Record<number, string> = {};

  //       res.data.forEach((item: any) => {
  //         if (item?.addon?.id && item?.price !== undefined) {
  //           const id = item.addon.id;
  //           const price = Number(item.price);
  //           customAddonPrices[id] = price;
  //           customAddonInputs[id] = `$${price.toFixed(2)}`;
  //         }
  //       });

  //       if (this.state.isCustomPriceEnabled) {
  //         this.setState({ customAddonPrices, customAddonInputs });
  //       }

  //       const data: any = [];
  //       if (res?.data.length > 0) {
  //         this.setState({ membershipIds: res?.data });
  //         res?.data.forEach((item: any) => {
  //           data.push(item.addon.id);
  //         });
  //         this.setState({ addonSelect: data });
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error loading addons:", error);
  //   } finally {
  //     this.setState({ loading: false });
  //   }
  // }

  // public handlePlanChange = (event: React.ChangeEvent<{ value: unknown }>) => {
  //   const selectedPlanId: any = event.target.value as string;
  //   const matchedPlan: any = this.state.planOptions?.find(
  //     (p: any) => Number(p.value) === Number(selectedPlanId)
  //   );
  //   const matchedPrice: number = matchedPlan ? Number(matchedPlan.price) : 0;

  //   this.setState({
  //     selectedPlan: selectedPlanId,
  //     planStandardPrice: matchedPrice
  //   }, () => {
  //     this.setState({
  //       addonSelect: [],
  //       editPaymentOptions: this.props.selectedRow?.subscription_type || 'cheque'
  //     });
  //   });
  // };


//   public handlePlanChange = (event: React.ChangeEvent<{ value: unknown }>) => {
//     const selectedPlanId: any = event.target.value as string;
//     const matchedPlan: any = this.state.planOptions?.find(
//       (p: any) => Number(p.value) === Number(selectedPlanId)
//     );
//     const matchedPrice: number = matchedPlan ? Number(matchedPlan.price) : 0;

//     // Filter out invalid addons based on new selectedPlan
//     const validAddons = this.state.addonSelect.filter((addonId: any) => 
//       Number(addonId) > (Number(selectedPlanId) - 2)
//     );
// console.log("Valid Addons after plan change:", validAddons);
//     this.setState({
//       selectedPlan: selectedPlanId,
//       planStandardPrice: matchedPrice,
//       addonSelect: validAddons,
//       editPaymentOptions: this.props.selectedRow?.subscription_type || 'cheque'
//     });
//   };

public async initializeModalData() {
    this.setState({ loading: true });

    try {
      const planRes: any = await this.buildGet(this, "payment/getPlan")();
      const addonRes: any = await this.buildGet(this, "payment/getAddonPlan")();

      console.log("Plan Response11:", planRes);
      console.log("Addon Response22:", addonRes);

      const planOptions = planRes?.data?.map((item: any) => ({
        label: item?.title,
        value: item?.id,
        price: item?.price,
      })) || [];

      const addonOptions = addonRes?.data?.map((item: any) => ({
        label: item?.title,
        value: item?.id,
        price: item?.price,
      })) || [];

      console.log("Plan Options:", planOptions);
      console.log("Addon Options:", addonOptions);

      const { selectedRow } = this.props;
      console.log("Selected Row:", selectedRow);

      const planId = selectedRow?.memberPayHistory?.plan?.id > 1
        ? selectedRow?.memberPayHistory?.plan?.id
        : 1;

      const initialPlanMatch: any = planOptions?.find((p: any) =>
        Number(p.value) === Number(planId)
      );
      const initialPlanPrice: number = initialPlanMatch
        ? Number(initialPlanMatch.price)
        : 0;

      const isCustomPrice = selectedRow?.is_custom_price || false;

      console.log("Setting state with planOptions:", planOptions);

      this.setState({
        planOptions,
        addonOptions,
        selectedPlan: planId,
        planStandardPrice: initialPlanPrice,
        customPlanPrice: selectedRow?.memberPayHistory?.price || 0,
        isCustomPriceEnabled: isCustomPrice,
        customPlanPriceInput: (selectedRow?.memberPayHistory?.price !== undefined &&
          selectedRow?.memberPayHistory?.price !== null &&
          isCustomPrice)
          ? `${Number(selectedRow?.memberPayHistory?.price).toFixed(2)}`
          : "",
        editPaymentOptions: selectedRow?.subscription_type || 'cheque',
        loading: false
      }, () => {
        console.log("State after update:", this.state);
        // ✅ हमेशा addons load करें, चाहे custom price हो या नहीं
        if (selectedRow?.memberPayHistory?.subscription_id) {
          this.loadAddonsForSelectedPlan();
        }
      });
    } catch (error) {
      console.error("Error initializing modal:", error);
      alert("Error loading plans: " + error);
      this.setState({ loading: false });
    }
  }
// public async loadAddonsForSelectedPlan() {
//     const { selectedRow } = this.props;
//     if (!selectedRow?.memberPayHistory?.subscription_id) {
//       return;
//     }

//     this.setState({ loading: true });
//     try {
//       const res: any = await this.buildGet(
//         this,
//         `payment/getOneAddonHistory/${selectedRow.memberPayHistory.subscription_id}`
//       )();

//       if (res?.status && Array.isArray(res.data)) {
//         const customAddonPrices: Record<number, number> = {};
//         const customAddonInputs: Record<number, string> = {};

//         res.data.forEach((item: any) => {
//           if (item?.addon?.id && item?.price !== undefined) {
//             const id = item.addon.id;
//             const price = Number(item.price);
//             customAddonPrices[id] = price;
//             customAddonInputs[id] = `$${price.toFixed(2)}`;
//           }
//         });

//         // ⚠️ यह line हटाएं या condition add करें
//         // if (this.state.isCustomPriceEnabled) {
//         //   this.setState({ customAddonPrices, customAddonInputs });
//         // }

//         // सिर्फ custom price होने पर ही prices set करें
//         const data: any = [];
//         if (res?.data.length > 0) {
//           this.setState({ membershipIds: res?.data });
//           res?.data.forEach((item: any) => {
//             data.push(item.addon.id);
//           });
          
//           // यहाँ condition add करें
//           if (this.state.isCustomPriceEnabled) {
//             this.setState({ 
//               addonSelect: data,
//               customAddonPrices, 
//               customAddonInputs 
//             });
//           } else {
//             this.setState({ addonSelect: data });
//           }
//         }
//       }
//     } catch (error) {
//       console.error("Error loading addons:", error);
//     } finally {
//       this.setState({ loading: false });
//     }
//   }

public async loadAddonsForSelectedPlan() {
    const { selectedRow } = this.props;
    if (!selectedRow?.memberPayHistory?.subscription_id) {
      return;
    }

    this.setState({ loading: true });
    try {
      const res: any = await this.buildGet(
        this,
        `payment/getOneAddonHistory/${selectedRow.memberPayHistory.subscription_id}`
      )();

      if (res?.status && Array.isArray(res.data)) {
        const customAddonPrices: Record<number, number> = {};
        const customAddonInputs: Record<number, string> = {};
        const data: any = [];

        res.data.forEach((item: any) => {
          if (item?.addon?.id) {
            const id = item.addon.id;
            data.push(id);
            
            // Custom prices ko store karo (baad mein use honge)
            if (item?.price !== undefined) {
              const price = Number(item.price);
              customAddonPrices[id] = price;
              customAddonInputs[id] = `$${price.toFixed(2)}`;
            }
          }
        });

        // ✅ Conditional setState without spread operator
        if (this.state.isCustomPriceEnabled) {
          this.setState({ 
            membershipIds: res?.data,
            addonSelect: data,
            customAddonPrices, 
            customAddonInputs
          });
        } else {
          this.setState({ 
            membershipIds: res?.data,
            addonSelect: data
          });
        }
      }
    } catch (error) {
      console.error("Error loading addons:", error);
    } finally {
      this.setState({ loading: false });
    }
  }
  
public handlePlanChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selectedPlanId: any = event.target.value as string;
    const currentPlanId = this.props.selectedRow?.memberPayHistory?.plan?.id;
    
    // Prevent downgrade - block if selected plan is lower than current plan
    if (currentPlanId && Number(selectedPlanId) < Number(currentPlanId)) {
      window.alert("Plan downgrade is not allowed. Please select a plan that is equal to or higher than your current plan.");
      return; // Don't proceed with the change
    }
    
    const matchedPlan: any = this.state.planOptions?.find(
      (p: any) => Number(p.value) === Number(selectedPlanId)
    );
    const matchedPrice: number = matchedPlan ? Number(matchedPlan.price) : 0;

    // Filter out invalid addons based on new selectedPlan
    const validAddons = this.state.addonSelect.filter((addonId: any) => 
      Number(addonId) > (Number(selectedPlanId) - 2)
    );
    
    console.log("Valid Addons after plan change:", validAddons);
    
    this.setState({
      selectedPlan: selectedPlanId,
      planStandardPrice: matchedPrice,
      addonSelect: validAddons,
      editPaymentOptions: this.props.selectedRow?.subscription_type || 'cheque',
      // Custom prices को भी filter करें
      customAddonPrices: validAddons.reduce((acc: any, id: any) => {
        if (this.state.customAddonPrices?.[id]) {
          acc[id] = this.state.customAddonPrices[id];
        }
        return acc;
      }, {}),
      customAddonInputs: validAddons.reduce((acc: any, id: any) => {
        if (this.state.customAddonInputs?.[id]) {
          acc[id] = this.state.customAddonInputs[id];
        }
        return acc;
      }, {})
    });
  };


  public handleAddonChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const { value } = event.target;
    console.log("Selected Addons:", value);
    this.setState({
      addonSelect: value as string[]
    });
  };

  // public handleCustomPriceToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   this.setState({ isCustomPriceEnabled: event.target.checked });
  // };

//   public handleCustomPriceToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
//   const isEnabled = event.target.checked;
  
//   if (!isEnabled) {
//     // Custom price off करते समय सभी custom prices clear करें
//     this.setState({ 
//       isCustomPriceEnabled: false,
//       customPlanPriceInput: "",
//       customPlanPrice: 0,
//       customAddonPrices: {},
//       customAddonInputs: {}
//     });
//   } else {
//     this.setState({ isCustomPriceEnabled: true });
//   }
// };
public handleCustomPriceToggle = async (event: React.ChangeEvent<HTMLInputElement>) => {
  const isEnabled = event.target.checked;
  
  if (!isEnabled) {
    // ✅ Custom price off करते समय सिर्फ prices clear करें, addons नहीं
    this.setState({ 
      isCustomPriceEnabled: false,
      customPlanPriceInput: "",
      customPlanPrice: 0,
      customAddonPrices: {},
      customAddonInputs: {}
      // addonSelect को clear नहीं करें
    });
  } else {
    // ✅ Custom price on करते समय prices load करें
    this.setState({ isCustomPriceEnabled: true }, async () => {
      if (this.props.selectedRow?.memberPayHistory?.subscription_id) {
        // Prices reload करें
        try {
          const res: any = await this.buildGet(
            this,
            `payment/getOneAddonHistory/${this.props.selectedRow.memberPayHistory.subscription_id}`
          )();

          if (res?.status && Array.isArray(res.data)) {
            const customAddonPrices: Record<number, number> = {};
            const customAddonInputs: Record<number, string> = {};

            res.data.forEach((item: any) => {
              if (item?.addon?.id && item?.price !== undefined) {
                const id = item.addon.id;
                const price = Number(item.price);
                customAddonPrices[id] = price;
                customAddonInputs[id] = `$${price.toFixed(2)}`;
              }
            });

            this.setState({ customAddonPrices, customAddonInputs });
          }
        } catch (error) {
          console.error("Error loading custom prices:", error);
        }
      }
    });
  }
};

  public handlePaymentTypeChange = (event: any) => {
    this.setState({ editPaymentOptions: event.target.value });
  };

  public manageAddonSelectUnselect() {
    const data = this.state.membershipIds?.map((item: any) => item?.addon?.id) || [];
    const newData = this.state.addonSelect || [];

    const NewAddon = newData?.filter((item: any) => !data.includes(item)) || [];
    const RemoveAddon = data?.filter((value: any) => !newData.includes(value)) || [];

    return { add: NewAddon, remove: [...RemoveAddon] };
  }

  // public async planUpgradeSubscription() {

  //   try {
  //     const userRes: any = await this.buildGet(this, "user")();
  //     const formattedAddonPrices = (this.state.addonOptions || []).map((opt: any) => ({
  //       id: Number(opt.value),
  //       price: Number(opt.price),
  //     }));

  //     const payload: any = {
  //       membership_id: this.props.selectedRow?.id,
  //       type: "plan",
  //       plan_id: this.state.selectedPlan,
  //       addon_id: formattedAddonPrices,
  //       subscription_type: this.state.editPaymentOptions,
  //       price: this.state.isCustomPriceEnabled ? this.state.customPlanPrice : this.state.planStandardPrice,
  //       updateby: userRes?.id,
  //       is_custom_price: this.state.isCustomPriceEnabled,
  //     };

  //     const res: any = await this.buildPut(
  //       this,
  //       `/payment/updateMembership`
  //     )(payload);
  //     return res;
  //   } catch (error) {
  //     return { isError: true, message: error };
  //   }
  // }

public async planUpgradeSubscription() {
  try {
    const userRes: any = await this.buildGet(this, "user")();
    
    // सिर्फ selected addons की list बनाएं
    const selectedAddonIds = this.state.addonSelect || [];
    const formattedAddonPrices = selectedAddonIds.map((addonId: any) => {
      const addon = this.state.addonOptions.find((opt: any) => 
        Number(opt.value) === Number(addonId)
      );
      
      // अगर custom price है तो वो use करें, नहीं तो standard price
      const price = this.state.isCustomPriceEnabled 
        ? (this.state.customAddonPrices?.[addonId] || 0)
        : (addon?.price || 0);
      
      return {
        id: Number(addonId),
        price: Number(price),
      };
    });

    const payload: any = {
      membership_id: this.props.selectedRow?.id,
      type: "plan",
      plan_id: this.state.selectedPlan,
      addon_id: formattedAddonPrices, // सिर्फ selected addons
      subscription_type: this.state.editPaymentOptions,
      price: this.state.isCustomPriceEnabled ? this.state.customPlanPrice : this.state.planStandardPrice,
      updateby: userRes?.id,
      is_custom_price: this.state.isCustomPriceEnabled,
    };

    const res: any = await this.buildPut(
      this,
      `/payment/updateMembership`
    )(payload);
    return res;
  } catch (error) {
    return { isError: true, message: error };
  }
}

  public async addonUpgradeSubscription() {
    // alert("addonUpgradeSubscription called");
    const removeIDs: any = [];
    if (this.state.membershipIds.length > 0) {
      this.state.membershipIds.forEach((item: any) => {
        this.manageAddonSelectUnselect().remove.forEach((items: any) => {
          if (items === item.addon.id) {
            removeIDs.push(item.id);
          }
        });
      });
    }

    const res: any = await this.buildGet<IUser>(this, "user")();
    let payload: any = {};

    if (this.state.isCustomPriceEnabled) {
      // alert("Custom Price Enabled in addonUpgradeSubscription");
      const addedAddonIds = this.state.addonSelect || [];
      const formattedAddonPrices = addedAddonIds.map((addonId: any) => {
        const price = this.state.customAddonPrices?.[addonId];
        return {
          id: Number(addonId),
          price: price ? Number(price) : 0,
        };
      });

      payload = {
        membership_id: this.props.selectedRow?.id,
        type: "addon",
        plan_id: this.state.selectedPlan,
        addon_id: formattedAddonPrices,
        remove_addon_id: removeIDs,
        subscription_type: this.state.editPaymentOptions,
        price: this.state.customPlanPrice,
        updateby: res?.id,
        is_custom_price: this.state.isCustomPriceEnabled,
      };
    }
    
    else {
      // alert("Standard Price in addonUpgradeSubscription");
      // const formattedAddonPrices = (this.state.addonOptions || []).map((opt: any) => ({
      //   id: Number(opt.value),
      //   price: Number(opt.price),
      // }));
     const addedAddonIds = this.state.addonSelect || [];

  const formattedAddonPrices = addedAddonIds.map((addonId: any) => {

    // Get addon object from addonOptions
    const matchedAddon = this.state.addonOptions.find(
      (opt: any) => Number(opt.value) === Number(addonId)
    );

    // Standard price from addonOptions
    const standardPrice = Number(matchedAddon?.price || 0);

    // Final price (custom OFF → use standard)
    const finalPrice = standardPrice;

    return {
      id: Number(addonId),
      price: finalPrice,
    };
  });

  payload = {
    membership_id: this.props.selectedRow?.id,
    type: "addon",
    plan_id: this.state.selectedPlan,
    addon_id: formattedAddonPrices,
    remove_addon_id: removeIDs,
    subscription_type: this.state.editPaymentOptions,
    updateby: res?.id,
    is_custom_price: false,
    price: this.state.planStandardPrice,
  };
}
    try {
      const apiRes: any = await this.buildPut(
        this,
        `/payment/updateMembership`
      )(payload);
      return apiRes;
    } catch (error) {
      return { isError: true, message: error };
    }
  }

  public submitUpgradePlanAddon = async () => {
    const { isCustomPriceEnabled, customPlanPriceInput, selectedPlan } = this.state;

    if (!selectedPlan) {
      alert("Please select a plan before submitting.");
      return;
    }

    const planPriceProvided =
      String(customPlanPriceInput || "").trim() !== "" &&
      customPlanPriceInput !== ".";

    if (isCustomPriceEnabled && !planPriceProvided) {
      alert("Please enter custom plan price.");
      return;
    }

    const selectedAddonIds: Array<string | number> = this.state.addonSelect || [];
    const missingAddonPrice = selectedAddonIds.find((id) => {
      const key = String(id);
      const price: any = this.state.customAddonPrices?.[key];
      const input: any = this.state.customAddonInputs?.[key];

      if (price === undefined || price === null) { return true; }
      if (input === "" || input === undefined) { return true; }
      if (typeof input === "string" && (input.trim() === "" || input === ".")) { return true; }
      if (Number(price) === 0 && input !== "0" && input !== "$0.00") { return true; }
      return false;
    });

    if (missingAddonPrice !== undefined && isCustomPriceEnabled) {
      alert("Please enter custom price for all selected addons.");
      return;
    }

    //  Extra validation: custom price mode me agar plan + addons ka total 0 ho
    //    aur subscription type "free" nahi hai, to alert dikhao aur submit rok do
    if (isCustomPriceEnabled) {
      const planPrice = Number(this.state.customPlanPrice || 0);

      const addonTotal: number = (selectedAddonIds || []).reduce<number>((sum, id: string | number) => {
        const key = String(id);
        const price = this.state.customAddonPrices?.[key];
        const numeric = price !== undefined && price !== null ? Number(price) : 0;
        return sum + (isNaN(numeric) ? 0 : numeric);
      }, 0);

      const grandTotal = planPrice + addonTotal;

      if (grandTotal === 0 && this.state.editPaymentOptions !== "free") {
        alert("Total custom price of plan and addons is 0. Please select subscription type 'Free'.");
        return;
      }
    }

    if (selectedPlan > 0 || (this.manageAddonSelectUnselect().add?.length > 0 ||
      this.manageAddonSelectUnselect().remove?.length > 0)) {
      if (selectedPlan === 7) {
        alert("Select Valid Plan or Addon for update subscription");
      } else {
        this.setState({ loading: true });

        try {
          if (selectedPlan === this.props.selectedRow?.memberPayHistory?.plan?.id) {
            const data1 = await this.addonUpgradeSubscription();
            if (!data1.status) {
              this.setState({ loading: false });
              alert(data1?.message);
            } else {
              this.setState({ loading: false });
              this.props.onUpgradeSubmit?.();
            }
          } else {
            if (this.manageAddonSelectUnselect().add?.length > 0 ||
              this.manageAddonSelectUnselect().remove?.length > 0) {
              const [data1, data2] = await Promise.all([
                this.planUpgradeSubscription(),
                this.addonUpgradeSubscription()
              ]);

              if (!data1.status) {
                this.setState({ loading: false });
                alert(data1?.message);
              } else if (!data2?.status) {
                this.setState({ loading: false });
                alert(data2?.message);
              } else {
                this.setState({ loading: false });
                this.props.onUpgradeSubmit?.();
              }
            } else {
              const data1 = await this.planUpgradeSubscription();
              if (!data1.status) {
                this.setState({ loading: false });
                alert(data1?.message);
              } else {
                this.setState({ loading: false });
                this.props.onUpgradeSubmit?.();
              }
            }
          }
        } catch (error) {
          console.error('Error:', error);
          this.setState({ loading: false });
          alert("Please try again!");
        }
      }
    } else {
      alert("Select Plan or Addon for update subscription");
    }
  };

  public render() {
    const { open, onClose } = this.props;
    const {
      planOptions,
      addonOptions,
      selectedPlan,
      addonSelect,
      editPaymentOptions,
      loading,
      isCustomPriceEnabled,
      customPlanPriceInput,
      planStandardPrice
    } = this.state;

    return (
      <Dialog className="subscription-dialog-box"  open={open} onClose={onClose} fullWidth={true} maxWidth="sm">
        <style>
          {`
            .changeLebelColor .MuiSelect-select,
            .changeLebelColor .MuiInputBase-input {
              color: rgb(0 0 0 / 54%);
              font-weight:400;
              font-size:14px;
            }
              .subscription-dialog-box .MuiDialog-paperScrollPaper {
                Height:auto; 
              }
            .changeLebelColor .MuiFormLabel-asterisk {
              color: #f44336 !important;
            }
            .price-wrapper {
              grid-template-columns: repeat(2, 1fr);
              display: grid;
              gap:10px;
            }
            .text-danger {
              color: #f44336;
            }
            .modal-subscription.modal-innerdiv {
                max-width: 680px;
                width: 100%;
            }
             #demo-simple-select-outlined {
                  padding: 5px 14px;
              }
          `}
        </style>
       <div className="modal-subscription modal-innerdiv">
        <DialogTitle style={{padding: "0"}}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" style={{ fontWeight: 700 }}>
              Select Subscription Plan
            </Typography>
            <span style={{ cursor: "pointer" }} onClick={onClose}>
              <CloseIcon />
            </span>
          </div>
        </DialogTitle>

        <DialogContent dividers={true} style={{paddingLeft: "0", paddingBottom: "0", paddingRight: "0"}}>
          {loading ? (
            <Grid container={true} justify="center" alignItems="center" style={{ minHeight: 200 }}>
              <CircularProgress />
            </Grid>
          ) : (
            <div style={{ maxHeight: "530px" }}>
              {console.log("Rendering with planOptions:", planOptions)}
              {console.log("Rendering with addonOptions:", addonOptions)} 
              {console.log("Selected Plan:", selectedPlan)}

              <FormControl variant="outlined" fullWidth={true}>
                <InputLabel id="plan-select-label">Plan Type</InputLabel>
                <Select
                  labelId="plan-select-label"
                  // value={selectedPlan || "1"}
                  value={selectedPlan ? selectedPlan : "1"}
                  onChange={this.handlePlanChange}
                  label="Plan Type"
                  id="demo-simple-select-outlined"
                >
                  {planOptions?.map((plan: any) => {
                    const currentPlanId = this.props.selectedRow?.memberPayHistory?.plan?.id;
                    // Disable plan if it's Free Trial (value === 1) OR if it's lower than current plan (downgrade)
                    const isDowngrade = currentPlanId && plan.value < currentPlanId;
                    const isDisabled = plan.value === 1 || isDowngrade;
                    
                    return (
                      <MenuItem
                        key={plan.value}
                        value={plan.value}
                        disabled={isDisabled}
                      >
                        <ListItemText
                          primary={plan.label}
                          secondary={`$${plan.price}/yr`}
                        />
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>

              <div style={{ marginTop: 15 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isCustomPriceEnabled}
                      onChange={this.handleCustomPriceToggle}
                      color="primary"
                    />
                  }
                  label="Want to add custom price?"
                />
              </div>

              {isCustomPriceEnabled && (
                <div className="changeLebelColor" style={{ marginTop: 10 }}>
                  <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                    <label htmlFor="customPrice" style={{ marginBottom: 5, fontWeight: 500 }}>
                      Custom Price for Plan <span className="text-danger">*</span>
                    </label>
                    <input
                      id="customPrice"
                      type="text"
                      value={customPlanPriceInput}
                      placeholder={
                        planOptions?.find((p: any) => Number(p.value) === Number(selectedPlan))
                          ? `$${Number(planStandardPrice).toFixed(2)} (Click here to edit)`
                          : "(Click here to edit)"
                      }
                      style={{
                        padding: "8px",
                        border: "none",
                        borderBottom: "1px solid #ccc",
                        borderRadius: "0px",
                        color: "rgb(0 0 0 / 54%)"
                      }}
                      onChange={(e) => {
                        const next = e.target.value;
                        const sanitized = next.replace(/[^0-9.]/g, "");
                        const parts = sanitized.split(".");
                        const normalized = parts.length > 2
                          ? `${parts[0]}.${parts.slice(1).join("")}`
                          : sanitized;
                        this.setState({ customPlanPriceInput: normalized });
                      }}
                      onBlur={() => {
                        const raw = customPlanPriceInput;
                        if (raw === "" || raw === ".") {
                          this.setState({ customPlanPrice: 0, customPlanPriceInput: "" });
                          return;
                        }
                        const num = Number(parseFloat(raw).toFixed(2));
                        if (!isNaN(num)) {
                          this.setState({
                            customPlanPrice: num,
                            customPlanPriceInput: `$${num.toFixed(2)}`,
                          });
                        } else {
                          this.setState({ customPlanPrice: 0, customPlanPriceInput: "" });
                        }
                      }}
                   
                    />
                  </div>
                </div>
              )}

                {addonOptions.length > 0 && selectedPlan && selectedPlan !== 1 && (
                                  // {addonOptions.length > 0  && (


                <FormControl
                  style={{
                    width: '100%',
                    marginTop: isCustomPriceEnabled ? "20px" : "15px"
                  }}
                >
                  


              <InputLabel>Select Addons</InputLabel>
<Select
  multiple={true}
  value={addonSelect}
  onChange={this.handleAddonChange}
  renderValue={(selected: unknown) => {
    const selectedLabels = (selected as string[])
      .map((val) => addonOptions.find((option: any) =>
        option.value === val)?.label)
      .filter((label): label is string => Boolean(label));
    return selectedLabels.join(', ');
  }}
>

  
    {addonOptions
  .filter((option: any) => 
    selectedPlan !== null && Number(option.value) > ((selectedPlan ?? 0) - 2)
  )
  .map((option: any) => (
    <MenuItem key={option.value} value={option.value}>
      <Checkbox checked={addonSelect.indexOf(option.value) > -1} />
      <ListItemText
        primary={option.label}
        secondary={`$${option?.price}/yr`}
      />
    </MenuItem>
  ))}
</Select>


 {/* <InputLabel>Select Addons</InputLabel>
                  <Select
                    multiple={true}
                    value={addonSelect}
                    onChange={this.handleAddonChange}
                    renderValue={(selected: unknown) => {
                      const selectedLabels = (selected as string[])
                        .map((val) => addonOptions.find((option: any) =>
                          option.value === val)?.label)
                        .filter((label): label is string => Boolean(label));
                      return selectedLabels.join(', ');
                    }}
                  >
                    {addonOptions.map((option: any) => (
                      <MenuItem key={option.value} value={option.value}>
                        <Checkbox checked={addonSelect.indexOf(option.value) > -1} />
                        <ListItemText
                          primary={option.label}
                          secondary={`$${option?.price}/yr`}
                        />
                      </MenuItem>
                    ))}
                  </Select> */}

                  <div className="price-wrapper">
                    {isCustomPriceEnabled &&
                      addonSelect
                        .sort((a: any, b: any) => Number(a) - Number(b))
                        .map((addonIdRaw: string | number, index: number) => {
                          const addonId = Number(addonIdRaw);
                          const addon = addonOptions.find(
                            (opt: any) => Number(opt.value) === addonId
                          );
                          if (!addon) { return null; }

                          const numericValue = this.state.customAddonPrices?.[addonId];
                          const inputValue = this.state.customAddonInputs?.[addonId] !== undefined
                            ? this.state.customAddonInputs[addonId]
                            : (numericValue !== undefined && numericValue !== null
                              ? `$${Number(numericValue).toFixed(2)}`
                              : "");

                          return (
                            <div
                              key={`${addonId}-${index}`}
                              style={{
                                marginTop: 10,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 10,
                              }}
                            >
                              <label style={{ margin: 0, width: "100%" }} htmlFor={`addon-${addonId}`}>
                                Custom Price for {addon.label} <span className="text-danger">*</span>
                                <input
                                  id={`addon-${addonId}`}
                                  type="text"
                                  value={inputValue}
                                  placeholder={`$${Number(addon.price).toFixed(2)} (Click here to edit)`}
                                  onChange={(e) => {
                                    const raw = e.target.value.replace(/[^0-9.]/g, "");
                                    this.setState((prev: any) => ({
                                      customAddonInputs: {
                                        ...prev.customAddonInputs,
                                        [addonId]: raw
                                      },
                                      customAddonPrices: {
                                        ...prev.customAddonPrices,
                                        [addonId]: raw ? parseFloat(raw) : 0
                                      },
                                    }));
                                  }}
                                  // onFocus={(e) => {
                                  //   requestAnimationFrame(() => e?.currentTarget?.select());
                                  // }}
                                  onFocus={(e) => {
                                    const inputEl = e.currentTarget;
                                    requestAnimationFrame(() => {
                                      try {
                                        inputEl.select();
                                      } catch {
                                        // ignore
                                      }
                                    });
                                  }}

                                  onBlur={() => {
                                    const raw = this.state.customAddonInputs?.[addonId] || "";
                                    if (raw === "" || raw === ".") {
                                      this.setState((prev: any) => ({
                                        customAddonPrices: {
                                          ...prev.customAddonPrices,
                                          [addonId]: 0
                                        },
                                        customAddonInputs: {
                                          ...prev.customAddonInputs,
                                          [addonId]: ""
                                        },
                                      }));
                                      return;
                                    }
                                    const num = Number(parseFloat(raw).toFixed(2));
                                    if (!isNaN(num)) {
                                      this.setState((prev: any) => ({
                                        customAddonPrices: {
                                          ...prev.customAddonPrices,
                                          [addonId]: num
                                        },
                                        customAddonInputs: {
                                          ...prev.customAddonInputs,
                                          [addonId]: `$${num.toFixed(2)}`
                                        },
                                      }));
                                    }
                                  }}
                                  style={{
                                    padding: "5px",
                                    color: "rgba(0, 0, 0, 0.54)",
                                    width: "100%",
                                    border: "none",
                                    borderBottom: "1px solid rgb(204, 204, 204)"
                                  }}
                                />
                              </label>
                            </div>
                          );
                        })}
                  </div>
                </FormControl>
              )}

              <div style={{ marginTop: 15 }}>
                <FormControl
                  component="fieldset"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    flexDirection: "row"
                  }}
                >
                  <Typography
                    component="legend"
                    style={{
                      fontSize: "17px",
                      color: "#000",
                      fontWeight: "500",
                      display: "flex",
                    width: "auto",
                    alignItems: "center",
                    float: "left",
               
                    }}
                  >
                    Subscription Type
                  </Typography>
                  <RadioGroup
                    style={{ flexDirection: "row" }}
                    value={editPaymentOptions}
                    onChange={this.handlePaymentTypeChange}
                  >
                    <FormControlLabel style={{marginBottom: 0}} value="cheque" control={<Radio />} label="Check" />
                    <FormControlLabel style={{marginBottom: 0}} value="stripe" control={<Radio />} label="Stripe" />
                    <FormControlLabel style={{marginBottom: 0}} value="free" control={<Radio />} label="Free" />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
          )}
        </DialogContent>

        <DialogActions>
          <Button 
          // onClick={onClose} 
          onClick={() => {
    const userConfirmed = window.confirm(
      "Are you sure you want to cancel?\nIf you cancel now, you will have to update your plan through the Membership Subscription page."
    );

    if (userConfirmed) {
      onClose(); 
    }
  }}
          disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              const currentPlanId = this.props.selectedRow?.memberPayHistory?.plan?.id;
              const selectedPlanId = this.state.selectedPlan;

              if (selectedPlanId && selectedPlanId < currentPlanId) {
                // Block downgrade - show alert and prevent submission
                window.alert("Plan downgrade is not allowed. Please select a plan that is equal to or higher than your current plan.");
                return;
              }
              this.submitUpgradePlanAddon();
            }}
            disabled={!selectedPlan || loading}
          >
            {loading ? <CircularProgress size={24} /> : "Submit"}
          </Button>
        </DialogActions>
        </div>
      </Dialog>
    );
  }
}

export default withStyles(styles)(withAxios(SubscriptionUpgradeModal));


// WEBPACK FOOTER //
// ./src/components/SubscriptionUpgradeModal.tsx